import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Audit, Sort } from './types';

export type State = {
	audits: Audit[],
	auditLoaded: boolean,
	sort: Sort
};

export const INITIAL_STATE: State = {
	audits: [],
	auditLoaded: false,
	sort: {
		date: 'desc'
	}
};

const listSlice = createSlice({
	name: 'auditList',
	initialState: INITIAL_STATE,
	reducers: {
		fetchAudit: state => {
			state.audits = [];
			state.auditLoaded = false;
		},
		fetchAuditSuccess: (state, action: PayloadAction<Audit[]>) => {
			state.audits = [...action.payload];
			state.auditLoaded = true;
		},
		fetchAuditError: state => {
			state.auditLoaded = true;
		},
		fetchNextPage: state => {
			state.auditLoaded = false;
		},
		fetchNextPageSuccess: (state, action: PayloadAction<Audit[]>) => {
			state.audits = [...state.audits, ...action.payload];
			state.auditLoaded = true;
		},
		fetchNextPageError: state => {
			state.auditLoaded = true;
		},
		applySort: (state, action: PayloadAction<{ field: string; order: 'asc' | 'desc' }>) => {
			state.audits = [];
			state.auditLoaded = false;
			state.sort = {
				...state.sort,
				[action.payload.field]: action.payload.order
			};
		},
		//TO TEST
		resubscribe: (state, action: PayloadAction<{ id: string; email: string }>) => {
		}
	}
});

export const {
	fetchAudit,
	fetchAuditSuccess,
	fetchAuditError,
	fetchNextPage,
	fetchNextPageSuccess,
	fetchNextPageError,
	applySort,
	resubscribe
} = listSlice.actions;

export default listSlice.reducer;
